export default __webpack_public_path__ + "d5a7419dd4a551667706de69a465c847.png";